import axios from 'axios'
import {errorHelper} from '../helper.js'
import { GET_LIST_ROLE_URL, PROPOSAL_LIST_ROLE_BAGE_URL, GET_LIST_ROLE_NEW_URL, GET_EXPERT_PROPOSAL_LIST_URL } from '../../../vars'

/**
 * @namespace RoleList
 */
export default {
    state: {
        paramsBsName: '',

    },
    mutations: {
        UPDATE_PARAMS_NAME_BS(state, name) {
            state.paramsBsName = name
        },
    },
    actions: {
        /**
         * Получает список данных по ролям(moderator)
         * @param {Object} ctx 
         * @param {Object} data Данные для получания списка по ролям
         * @returns {Object} Дананые резьтатат запроса
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof RoleList
         */
        async GET_LIST_ROLE(ctx, data) {

            let allUrl = data.hasOwnProperty('station') ?
            `${GET_LIST_ROLE_URL}?slug=${data.slug}&expand=[%22status%22,%22current_status%22,%22files%22]&page=${data.page}&station=${data.station}` :
            `${GET_LIST_ROLE_URL}?slug=${data.slug}&expand=[%22status%22,%22current_status%22,%22files%22]&page=${data.page}`;

            try {
                const res = await axios.get(allUrl, { 
                    headers: {
                      Authorization: `Token ${localStorage.token}`
                }});
                return res
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
        },

        /**
         * Получает список данных по ролям(moderator)
         * @param {Object} ctx 
         * @param {Object} data Данные для получания списка по ролям
         * @returns {Object} Данные резьтатат запроса
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof RoleList
         */
         async GET_LIST_ROLE_NEW(ctx, data) {

            let allUrl = `${GET_LIST_ROLE_NEW_URL}?status_id=${data.status_id}&page=${data.page}`;
            if(data.hasOwnProperty('station_id'))
                allUrl = allUrl + `&station_id=${data.station_id}`
            if(data.hasOwnProperty('expert_id'))
                allUrl = allUrl + `&expert_id=${data.expert_id}`
            if(data.hasOwnProperty('need_bs_comment'))
                allUrl = allUrl + `&need_bs_comment=${data.need_bs_comment}`

            try {
                const res = await axios.get(allUrl, { 
                    headers: {
                      Authorization: `Token ${localStorage.token}`
                }});
                // console.log('werwerwerada', res)
                return res
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
        },

        /**
         * Получает список proposals by expert
         * @param {Object} ctx 
         * @param {Object} data Данные для получания списка
         * @returns {Object} Данные резьтатат запроса
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof RoleList
         */
        async GET_EXPERT_PROPOSAL_LIST(ctx, data) {
            try {
                const res = await axios.get(`${GET_EXPERT_PROPOSAL_LIST_URL}?expert_id=${data.expert_id}`, { 
                    headers: {
                      Authorization: `Token ${localStorage.token}`
                }});
                // console.log('GET_EXPERT_PROPOSAL_LIST', res)
                return res
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
        },

        /**
         * Получает список данных по ролям(детально?)
         * @param {Object} ctx 
         * @param {Object} data Данные для получания списка по ролям
         * @returns {Object} Данные результата запроса
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof RoleList
         */
        async GET_LIST_ROLE_BAGE(ctx, data) {
            try {
                const res = await axios.get(`${PROPOSAL_LIST_ROLE_BAGE_URL}`, { 
                    headers: {
                      Authorization: `Token ${localStorage.token}`
                }});
                return res
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
        }
    },
    getters: {
        GETTERS_PARAMS_BS_NAME(state) {
            return state.paramsBsName
        }
    }
}